import { useModuleNavigation } from "@/common/hooks/use-navigation";
import { DashboardSection } from "@/components/dashboard/dashboard-section";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { NoPermissionCard } from "@/components/no-permission-card/no-permission-card";
import { TruckIcon, UserIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { UserMetric } from "./_components/user-metric";
import { VehicleMetric } from "./_components/vehicle-metric";

export function MasterdataDashboardView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const masterdataConfig = useModuleNavigation("masterdata");
  const pageTitle = t("masterdata:Masterdata") + " " + t("common:Dashboard");
  const pageSubtitle = t("masterdata:DashboardDescription");

  if (!masterdataConfig) {
    return <NoPermissionCard />;
  }

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Default} title={pageTitle} subTitle={pageSubtitle}>
      <DashboardSection title={t("masterdata:UserStatistics")} icon={UserIcon}>
        <UserMetric />
      </DashboardSection>

      <DashboardSection title={t("masterdata:VehicleStatistics")} icon={TruckIcon}>
        <VehicleMetric />
      </DashboardSection>
    </CenteredLayout>
  );
}
